export { default } from './BounceAnimation.js';
